import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Forums', path: '/forums' },
  { label: 'News', path: '/news' },
  { label: 'Links', path: '/links' },
  { label: 'Team', path: '/team' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-12 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <img
            src="https://vvuihauowiettkqumjzf.supabase.co/storage/v1/object/public/ppo/76919f.gif"
            alt="Purple Pride Logo"
            className="w-10 h-10 rounded-full object-cover"
          />
          <span
            className={`font-black text-xl tracking-widest uppercase transition-colors duration-300 ${
              scrolled ? 'text-[#4a1a6b]' : 'text-white'
            }`}
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            Purple Pride
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-semibold tracking-widest uppercase transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                location.pathname === link.path
                  ? scrolled
                    ? 'text-[#4a1a6b] border-b-2 border-[#4a1a6b]'
                    : 'text-[#ffd700] border-b-2 border-[#ffd700]'
                  : scrolled
                  ? 'text-gray-700 hover:text-[#4a1a6b]'
                  : 'text-white/90 hover:text-white'
              }`}
              style={{ fontFamily: "'Oswald', sans-serif" }}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="whitespace-nowrap px-5 py-2 rounded-full text-sm font-bold tracking-widest uppercase cursor-pointer transition-all duration-300 bg-[#4a1a6b] text-white hover:bg-[#ffd700] hover:text-[#4a1a6b]"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            Contact
          </Link>
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden flex items-center justify-center w-8 h-8 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-2xl ${scrolled ? 'text-[#4a1a6b]' : 'text-white'} ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMenuOpen(false)}
              className="text-sm font-bold tracking-widest uppercase text-gray-700 hover:text-[#4a1a6b] cursor-pointer"
              style={{ fontFamily: "'Oswald', sans-serif" }}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            onClick={() => setMenuOpen(false)}
            className="whitespace-nowrap px-5 py-2 rounded-full text-sm font-bold tracking-widest uppercase cursor-pointer bg-[#4a1a6b] text-white text-center"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            Contact
          </Link>
        </div>
      )}
    </header>
  );
}
